import type { SxProps, Theme } from '@mui/material';

export const styles = {
    warning: (theme: Theme): SxProps<Theme> => ({
        p: 1.5,
        borderRadius: '6px',
        backgroundColor: theme.palette.yellow[30],
        color: theme.palette.yellow[900],
        fontSize: '13px',
        mb: 2,
    }),
    loadingRow: {
        display: 'flex',
        justifyContent: 'center',
        mt: 4,
    } as SxProps<Theme>,
    emptyMessage: (theme: Theme): SxProps<Theme> => ({
        mt: 2,
        p: 1.5,
        borderRadius: '6px',
        backgroundColor: theme.palette.blue[30],
        color: theme.palette.blue.main,
        fontSize: '13px',
    }),
};
